import React from 'react';

const AllNotificationCard = React.memo(({ notification, onClick }) => {
  const formatTimeSinceCreated = (createdAt) => {
    const createdDate = new Date(createdAt);
    const nowMoscow = new Date();
    nowMoscow.setHours(nowMoscow.getHours() + 3); // Конвертируем в московское время (UTC+3)
    
    const diffMs = nowMoscow - createdDate;
    const diffSeconds = Math.floor(diffMs / 1000);
    const diffMinutes = Math.floor(diffSeconds / 60);
    const diffHours = Math.floor(diffMinutes / 60);
    const diffDays = Math.floor(diffHours / 24);
    
    if (diffDays >= 30) {
      const diffMonths = Math.floor(diffDays / 30);
      return `${diffMonths} мес. назад`;
    }
    
    if (diffDays >= 1) {
      return `${diffDays} дн. назад`;
    }
    
    if (diffHours >= 1) {
      return `${diffHours} ч. назад`;
    }
    
    if (diffMinutes >= 1) {
      return `${diffMinutes} мин. назад`;
    }
    
    return 'только что';
  };

  return (
    <div
      className={`notification-card all-notification-card ${notification.approve ? '' : 'unread'}`}
      onClick={onClick}
    >
      <div className="notification-card-header">
        <span className="notification-card-title">{notification.title}</span>
        <span className="notification-card-time">
          {formatTimeSinceCreated(notification.created_at)}
        </span>
      </div>
      <p className="notification-card-descr">{notification.descr}</p>
    </div>
  );
});

export default AllNotificationCard;
